import React from 'react'
import { Helmet } from 'react-helmet'

export const AppMeta = () => (
  <Helmet>
    <title>RadianBethencourt.com</title>
    <meta name="description" content="Payment Links" />
    <meta property="og:title" content="radianbethencourt.com" />
    <meta property="og:url" content="https://radianbethencourt.com" />
    <meta property="og:site_name" content="radianbethencourt.com" />
    <meta property="og:type" content="article" />
    <meta property="og:description" content="radianbethencourt.com" />
    <meta property="og:image" content="/ogimage.png" />
  </Helmet>
)
